import { useContext, useMemo } from "react";
import insuranceTypeNames from "constants/insuranceTypeNames";
import { ParamsContext } from "providers/ParamsContext";

export const useInsuranceTypeConfiguration = () => {
  const { insuranceTypeConfigurations } = useContext(ParamsContext);

  const configuration = useMemo(
    () => ({
      rca: insuranceTypeConfigurations?.find(x => x.insuranceTypeName === insuranceTypeNames.RCA),
      casco: insuranceTypeConfigurations?.find(x => x.insuranceTypeName === insuranceTypeNames.CASCO),
      rti: insuranceTypeConfigurations?.find(x => x.insuranceTypeName === insuranceTypeNames.RTI)
    }),
    [insuranceTypeConfigurations]
  );

  return configuration;
};
